let listeners = [];

/**
 * Registrácia poslucháča pre zobrazovanie Error Modálu.
 */
export const subscribeErrorModal = (callback) => {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((l) => l !== callback);
  };
};

/**
 * Zobrazí globálne Error Modál s ľubovoľnou správou.
 */
export const showErrorModal = (message, title = "Upozornenie") => {
  listeners.forEach((listener) => listener({ message, title }));
};

/**
 * Pomocná funkcia na spracovanie a odchytenie chybových hlások z backendu (Axios).
 *
 * @param {Error} error - Objekt zachytenej chyby z catch bloku
 * @param {Object|string} [options] - Možnosti alebo reťazec pre fallback správy
 * @param {boolean} [options.showAlert=false] - Ak je true, zobrazí Error Modál so správou
 * @param {string} [options.title="Upozornenie"] - Titulok pre Error Modál
 * @param {Function} [options.onError] - Callback s vyextrahovanou správou chyby
 * @param {string} [options.fallbackMessage] - Náhradná správa ak backend nevráti text chyby
 * @returns {string} Vyextrahovaná správa chyby
 */
export const handleApiError = (error, options = {}) => {
  const fallback =
    typeof options === "string"
      ? options
      : options.fallbackMessage || "Nastal problém pri komunikácii so serverom.";
  const showAlert = typeof options === "object" ? !!options.showAlert : false;
  const title = typeof options === "object" ? options.title || "Upozornenie" : "Upozornenie";
  const onError = typeof options === "object" ? options.onError : null;

  const backendMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    (typeof error?.response?.data === "string" ? error.response.data : null);

  const errorMessage = backendMessage || error?.message || fallback;

  console.error("API Chyba:", errorMessage, error);

  if (showAlert) {
    showErrorModal(errorMessage, title);
  }

  if (typeof onError === "function") {
    onError(errorMessage, error);
  }

  return errorMessage;
};
